import { JobApplicantsProvider } from './job-applicants-provider';

import { JobApplicants } from './InnerAccountdetail';

export function FeatureJobApplicants() {
   return (
      <JobApplicantsProvider>
         <JobApplicants></JobApplicants>
      </JobApplicantsProvider>
   );
}
